import { render, staticRenderFns } from "./subSkillScores.vue?vue&type=template&id=6b1a6088&scoped=true"
import script from "./subSkillScores.vue?vue&type=script&lang=js"
export * from "./subSkillScores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1a6088",
  null
  
)

export default component.exports